import { WindowModelType } from 'src/models';
// import { useEffect, useState } from 'react';

// export const useWindowWidth = (): number => {
//     const [width, setWidth]: [number, any] = useState(window.innerWidth);

//     const handleResize = () => {
//         setWidth(window.innerWidth);
//     };

//     useEffect(() => {
//         window.addEventListener('resize', handleResize);
//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, []);

//     return width;
// };

export const useWindowModel = (): WindowModelType => {
    // const width = useWindowWidth();
    const model: WindowModelType = 'pad';
    // if (width < 768) {
    //     model = 'phone';
    // } else if (width >= 768 && width < 1000) {
    //     model = 'pad';
    // } else if (width >= 1000 && width < 1180) {
    //     model = 'mini';
    // } else if (width >= 1180) {
    //     model = 'normal';
    // }
    // if ( width >= 1180) {
    //     model = 'normal';
    // }
    return model;
};



// WEBPACK FOOTER //
// ./src/hooks/useWindowModel.ts